import { render, staticRenderFns } from "./SliderConfig.vue?vue&type=template&id=51adc98a&scoped=true"
import script from "./SliderConfig.vue?vue&type=script&lang=js"
export * from "./SliderConfig.vue?vue&type=script&lang=js"
import style0 from "./SliderConfig.vue?vue&type=style&index=0&id=51adc98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51adc98a",
  null
  
)

export default component.exports